import { render, staticRenderFns } from "./SelectionAlternatives.vue?vue&type=template&id=7e916914&scoped=true"
import script from "./SelectionAlternatives.vue?vue&type=script&lang=js"
export * from "./SelectionAlternatives.vue?vue&type=script&lang=js"
import style0 from "./SelectionAlternatives.vue?vue&type=style&index=0&id=7e916914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e916914",
  null
  
)

export default component.exports